import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates whether the value of form control is not one of the forbidden ones
 *
 * @param forbiddenNames an array of forbidden names
 * @returns validator function
 */
export function forbiddenNameValidator(forbiddenNames: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        let forbidden = false;
        const value = control.value?.toLowerCase();
        for (const element of forbiddenNames) {
            if (element?.toLowerCase().trim() === value.trim()) {
                forbidden = true;
                break;
            }
        }
        return forbidden ? { forbiddenName: { value: control.value } } : null;
    };
}
